@if (loaded) {
  <div class="carbon_allowance_container">
    @if (policy) {
      <div class="flex-row-container flex-row-container--between">
        <span class="header_span">
          @if (policy.carbonPolicySource === CarbonPolicySource.User) {
            <i class="ico-person"></i>
          }
          @if (policy.carbonPolicySource === CarbonPolicySource.Office) {
            <i class="ico-hotel"></i>
          }
          @if (policy.carbonPolicySource === CarbonPolicySource.Company) {
            <i class="ico-hotel"></i>
          }
          @if (policy.carbonPolicySource === CarbonPolicySource.Division) {
            <i class="ico-hotel"></i>
          }
          {{ policyHolder }}
        </span>
        <dl class="header_span">
          <dt><span i18n="@@CO2DateRange">Date Range</span>:</dt>
          <dd>{{ startOfPeriod }} - {{ endOfPeriod }}</dd>
        </dl>
      </div>
    }
    @if (policy) {
      <div class="report-container">
        <div class="progress-report">
          <div
            class="progress-bar progress-bar-striped bg-success bg-danger"
            role="progressbar"
            [attr.aria-valuenow]="calculatedRemaingCo2Percentage"
            aria-valuemin="0"
            aria-valuemax="100"
            style="width: 100%"
            [attr.aria-valuetext]="'Remaining CO2 Allowance'"
          >
            @if (calculatedRemaingCo2Percentage === remainingCo2Percentage) {
              <span class="show_text"
                >{{ remainingCo2Percentage }}% ({{ policy.remainingCo2 }}kg/{{
                  policy.totalCo2
                }}kg)</span
              >
            }
            @if (calculatedRemaingCo2Percentage !== remainingCo2Percentage) {
              <span class="show_text">
                @if (!displayItinerary) {
                  <span i18n="@@CO2AdjustedWithBasket">Adjusted with basket</span>
                }
                @if (displayItinerary) {
                  <span i18n="@@CO2AdjustedWithItinerary">Adjusted with itinerary</span>
                }
                {{ calculatedRemaingCo2Percentage }}% ({{ adjustedTotal }}kg/{{
                  policy.totalCo2
                }}kg)</span
              >
            }
          </div>
        </div>
        <!-- Overlay bar for when we can select bookings with carbon -->
        <!-- TODO - implement a listener to update this based off of items in the basket -->
        <!--  -->
        @if (calculatedRemaingCo2Percentage > 0) {
          <div class="progress-report adjusted-report">
            <div
              class="progress-bar progress-bar-striped bg-success"
              role="progressbar"
              [attr.aria-valuenow]="calculatedRemaingCo2Percentage"
              aria-valuemin="0"
              aria-valuemax="100"
              [style.width.%]="calculatedRemaingCo2Percentage"
              [attr.aria-valuetext]="
                'Remaining CO2 Allowance Adjusted with ' +
                  (displayItinerary ? 'Itinerary' : 'Basket') | translate
              "
            ></div>
          </div>
        }
        <!-- <p><ngb-progressbar class="progress-report" type="success" [showValue]="true" [height]="'3rem'" [value]="carbonAllowancePolicy.remainingCo2" [max]="carbonAllowancePolicy.totalCo2" [striped]="true"></ngb-progressbar></p> -->
      </div>
    }
    @if (co2PerItem >= 0) {
      <p class="co2_item_container">
        @if (!displayItinerary) {
          <span i18n="@@co2_message_1">The current basket item uses</span>
        }
        @if (displayItinerary) {
          <span i18n="@@co2_message_1_itinerary">The current itinerary item uses</span>
        }
        <span>&nbsp;{{ co2PerItem }}</span
        >&nbsp;<span i18n="@flight_kg">kg</span> <span i18n="@flight_leg_co2">&nbsp;CO</span
        ><sub i18n="@flight_leg_2">2</sub>
        <span i18n="@@co2_message_2">.&nbsp;This accounts for</span
        ><span
          >&nbsp;{{ calculatePercentage() }}%<span i18n="@@co2_message_3">
            of the allowance for this period.</span
          ></span
        >
      </p>
    }
  </div>
}
